<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.Branch.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtBranchName"><small class="text-danger">*</small> {{$lang.Branch.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtBranchName"
                          :placeholder="$lang.Branch.PlaceholderEnterName"
                          v-model="form.name.value"
                          :maxlength="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtBranchName"><small class="text-danger">*</small> Sigla:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtBranchName"
                          :placeholder="'Digite a Sigla'"
                          v-model="form.initials.value"
                          :maxlength="form.initials.maxlength"
                          :required="form.initials.required"
                          :state="form.initials.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger">*</small> Empresa:</label>
          <div class="input-group">
            <b-form-select v-model="form.companyID.value" :options="form.companyID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger">*</small> Empreendimento:</label>
          <div class="input-group">
            <b-form-select v-model="form.development.value" :options="form.development.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtGroup"><small class="text-danger">*</small> Estado:</label>
          <div class="input-group">
            <b-form-select v-model="form.stateID.value" :options="form.stateID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger">*</small> Cidade:</label>
          <div class="input-group">
            <b-form-select v-model="form.cityID.value" :options="form.cityID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtGroup"><small class="text-danger">*</small> Filial SAP:</label>
          <div class="input-group">
            <b-form-select v-model="form.development.value" :options="form.development.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pt-2">
          <label for="txtDescription"> {{$lang.Branch.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.description.value"
                      :placeholder="$lang.Branch.PlaceholderEnterDescription"
                      :rows="form.description.rows"
                      :maxlength="form.description.maxlength"
                      :noResize="form.description.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
            :columns="[
              'Empresa',
              $lang.Branch.DataTable.Name,
              'Sigla',
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.empresa ? obj.empresa.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.sigla" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import Branch from './branch.js'

export default Branch
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/branch/branch.vue